module.exports = __webpack_public_path__ + "img/vodacom-trivia-soccer-bg-desktop.3a9c1ead.png";